import { createSlice } from '@reduxjs/toolkit';

const initialState: { name: string; id: number | undefined } = {
  id: undefined,
  name: '',
};

export const ProjectTemplateSlice = createSlice({
  name: 'project-template',
  initialState,
  reducers: {
    clearProjectTemplate: (_state) => initialState,
    setProjectTemplate(state, { payload }) {
      return { ...state, ...payload };
    },
  },
});

export const { setProjectTemplate, clearProjectTemplate } = ProjectTemplateSlice.actions;

export default ProjectTemplateSlice.reducer;
